/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useState, useEffect } from "react";
import Buttons from "components/Buttons";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { connect } from "react-redux";
import { setProductPrevious } from "store/actions/GlobalAction";

const Cart = memo(props => {
	const classes = useStyles();
	const {
		product,
		updateChangeListProduct,
		productPrevious,
		setProductPrevious
	} = props;

	const [isSelect, setSelect] = useState(product.isSelected);
	const handleSelectCart = item => {
		if (item?.stock !== 0) {
			setSelect(!isSelect);
			setProductPrevious({
				id: item?.id,
				isSelect: !isSelect
			});
			updateChangeListProduct(item);
		}
	};

	useEffect(() => {
		if (!productPrevious) {
			return;
		}
		productPrevious.forEach(productPreviou => {
			if (product?.id !== productPreviou?.id) {
				return;
			}
			setSelect(productPreviou?.isSelect);
		});
	}, [JSON.stringify(productPrevious)]);

	return (
		<Grid item xs={6}>
			<Buttons
				variant="contained"
				color="primary"
				className={isSelect ? classes.btnSelect : classes.btnUnSelect}
				iscenter={true}
				disabled={product?.stock === 0}
				onClick={() => handleSelectCart(product)}
			>
				{!isSelect ? "Chọn mua" : "Đã chọn"}
			</Buttons>
		</Grid>
	);
});

const mapStateToProps = state => {
	return {
		productPrevious: state.globalReducer.productPrevious
	};
};

const mapDispatchToProps = dispatch => {
	return {
		setProductPrevious: product => {
			dispatch(setProductPrevious(product));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
